import classNames from "classnames";
import MobileChecker from "../../shared/utils/MobileChecker"
import PropTypes from 'prop-types'
import React from 'react'
import Header from '../../PrincipalPaydown/components/Hero/Header'
import UnlockLater from '../../CreditLimit/components/utilization/UnlockLater'

function UnlockSoon({unlockDate, redirectTo}) {
  const isMobile = MobileChecker();

  function renderTitle({label = ''}) {
    var text = isMobile ? label.replace('<br/>', ' ') : label
    return <strong className="copy -darkBlue _displayBlock" dangerouslySetInnerHTML={{__html: text}}></strong>
  }

  function renderButton({path = '/', label = 'Upload a document'}) {
    return(
      <button className='ds-btn -primary --block'
        data-testid='trade-doc-upload-btn'
        data-path={path}
        onClick={() => { redirectTo(path) }}>
        {label}
        </button>
    )
  };

  function sectionClassName({isInitialElement = false} = {}) {
    let base = 'cardSection _textAlign_center'
    if(isInitialElement && !isMobile) { return classNames(base, '_borderWidth--none')}
    return base
  }

  return(
    <div className='ds-card' data-testid='unlock-soon-card'>
      <div className="cardSection _alignCenter">
        <Header containerClassName='_marginTop--small' text="Submit your invoices and purchase orders for pre-approval" />
        <div className='cardSection _verticalPadding--none _horizontalPadding--none _withColumns _justifyContent-center _alignItemsInitial'>
          <section className={sectionClassName({isInitialElement: true})} style={{flex: 1}}>
            {renderTitle({label: 'Collect your<br/>unpaid invoices'})}
            {renderButton({path: '/invoices/new', label: 'Upload an invoice'})}
          </section>
          <section className={sectionClassName()} style={{flex: 1}}>
            {renderTitle({label: 'Take on<br/>more orders'})}
            {renderButton({path: '/purchase_orders/new', label: 'Upload a p.o.'})}
          </section>
        </div>
      </div>
      <UnlockLater unlockDate={unlockDate}/>
    </div>
  )
}

UnlockSoon.propTypes = {
  unlockDate: PropTypes.instanceOf(Date).isRequired,
  redirectTo: PropTypes.func.isRequired
}

export default UnlockSoon



// WEBPACK FOOTER //
// ./src/features/applyNow/components/UnlockSoon.js